import { create } from "zustand";

export const useExitOrdersStore = create((set, get) => ({
    orders: [],
    updateVersion: 0,

    addOrUpdateOrder: (order) =>
        set((state) => {
            const incomingOrder = {
                ...order,
                order_id: String(order.order_id),
            };

            const idx = state.orders.findIndex(
                (o) => String(o.order_id) === incomingOrder.order_id
            );

            let newOrders;

            if (idx !== -1) {
                newOrders = [...state.orders];
                newOrders[idx] = {
                    ...newOrders[idx],
                    ...incomingOrder,
                };
            } else {
                newOrders = [...state.orders, incomingOrder];
            }

            return {
                orders: newOrders,
                updateVersion: state.updateVersion + 1,
            };
        }),

    removeOrder: (order_id) =>
        set((state) => {
            const id = String(order_id);
            return {
                orders: state.orders.filter((o) => String(o.order_id) !== id),
                updateVersion: state.updateVersion + 1,
            };
        }),

    clearOrders: () => set({ orders: [], updateVersion: 0 }),
}));
